export const kakaoChannel = () => {
  const Kakao = typeof window !== "undefined" ? window.Kakao : null;
  if (!Kakao) {
    return;
  }

  const jsKey = process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY;
  if (!jsKey) {
    return;
  }

  if (!Kakao.isInitialized()) {
    Kakao.init(jsKey);
  }

  const channelPublicId = process.env.REACT_APP_KAKAO_CHANNEL_PUBLIC_ID;

  Kakao.Channel.chat({ channelPublicId });
};
